/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DeliveryBoxIsoIcon16Light } from './DeliveryBoxIsoIcon16Light';
import { DeliveryBoxIsoIcon16Regular } from './DeliveryBoxIsoIcon16Regular';
import { DeliveryBoxIsoIcon16Solid } from './DeliveryBoxIsoIcon16Solid';
import { DeliveryBoxIsoIcon20Light } from './DeliveryBoxIsoIcon20Light';
import { DeliveryBoxIsoIcon20Regular } from './DeliveryBoxIsoIcon20Regular';
import { DeliveryBoxIsoIcon20Solid } from './DeliveryBoxIsoIcon20Solid';
import { DeliveryBoxIsoIcon24Regular } from './DeliveryBoxIsoIcon24Regular';
import { DeliveryBoxIsoIcon24Solid } from './DeliveryBoxIsoIcon24Solid';
import { DeliveryBoxIsoIcon32Regular } from './DeliveryBoxIsoIcon32Regular';
import { DeliveryBoxIsoIcon64Regular } from './DeliveryBoxIsoIcon64Regular';
var sizes = {
    16: {
        light: DeliveryBoxIsoIcon16Light,
        regular: DeliveryBoxIsoIcon16Regular,
        solid: DeliveryBoxIsoIcon16Solid,
    },
    20: {
        light: DeliveryBoxIsoIcon20Light,
        regular: DeliveryBoxIsoIcon20Regular,
        solid: DeliveryBoxIsoIcon20Solid,
    },
    24: {
        regular: DeliveryBoxIsoIcon24Regular,
        solid: DeliveryBoxIsoIcon24Solid,
    },
    32: {
        regular: DeliveryBoxIsoIcon32Regular,
    },
    64: {
        regular: DeliveryBoxIsoIcon64Regular,
    },
};
export var DeliveryBoxIsoIcon = forwardRef('DeliveryBoxIsoIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
